import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { BLOCKS } from "../html";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const { type } = BLOCKS.QUOTE;

const isBlockquote = (editor: Editor) => editor.value.blocks.some(block => block.type === type);

const toggleBlockquote = (editor: Editor): Editor => {
  const newBlockType = isBlockquote(editor) ? BLOCKS.PARAGRAPH.type : type;
  editor.setBlocks(newBlockType);
  return editor;
};

/**
 * Slate plugin to handle quote blocks
 */
export const Blockquote: Plugin[] = [
  AddIsToggledQuery(type, isBlockquote),
  AddToggleCommand(type, toggleBlockquote),
  {
    renderBlock: (props, controller, next) => {
      const { attributes, children, node } = props;
      if (node.type === type) {
        return (
          <blockquote {...attributes}>
            {children}
          </blockquote>
        );
      }
      else {
        return next();
      }
    },
  },
];
